// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardEditPickupLocationController {
   $uibModalInstance: any
   alerts: any
   bibId: any
   configService: any
   hasError: any
   holdId: any
   i18n: any
   isLoading: any
   pickupLocations: any
   rtaAvailabilityService: any
   selectedPickupLocation: any
   showMode: any
   sierraService: any
   constructor($uibModalInstance: any, rtaAvailabilityService: any, sierraService: any, configService: any, translationService: any, alertService: any, holdId: any, bibId: any) {
      this.$uibModalInstance = $uibModalInstance
      this.rtaAvailabilityService = rtaAvailabilityService
      this.sierraService = sierraService
      this.configService = configService
      this.i18n = translationService
      this.alerts = alertService
      this.holdId = holdId
      this.bibId = bibId
      this.pickupLocations = []
      this.selectedPickupLocation = ""
      this.isLoading = false
      this.showMode = 'FORM'
      this.hasError = false
   }

   $onInit() {
      this.isLoading = true
    
      return this.sierraService
         .getHoldRequestByBibId(this.bibId)
         .then((response: any) => {
            this.isLoading = false
            if (response.data.holdshelf) {
               this.pickupLocations = response.data.holdshelf.locations
            } else { 
               this.showMode = 'SUMMARY'
               this.alerts.setAlert('requestHoldError', this.i18n.translations.PICKUP_LOCATIONS_EMPTY)
            }

            return this.hasError = false
         })
         .catch((error: any) => {
            this.showMode = 'SUMMARY'
            this.alerts.setAlert('requestHoldError', this.i18n.translate(this.i18n.translations.REQUEST_HOLD_FAILED, {reason: error.data.description}))
            return this.hasError = true
         })
   }

   cancel() {
      return this.$uibModalInstance.dismiss('cancel')
   }

   accept() {
      if (this.hasError) {
         return this.$uibModalInstance.dismiss('cancel')
      } else {
         return this.$uibModalInstance.close('ok')
      }
   }

   save() {
      this.isLoading = true

      const hold = {
         pickupLocation: this.selectedPickupLocation?.code?.trim()
      }

      return this.sierraService
         .updateHold(this.holdId, hold)
         .then((data: any) => {
            this.isLoading = false  
            this.showMode = 'SUMMARY'
            this.alerts.setAlert('requestHoldSuccess', this.i18n.translations.REQUEST_HOLD_UPDATED)
            return this.hasError = false
         })
         .catch((error: any) => { 
            this.isLoading = false
            this.showMode = 'SUMMARY'
            const errorMessage = error.data.description || error.data.msg
            this.alerts.setAlert('requestHoldError', this.i18n.translate(this.i18n.translations.REQUEST_HOLD_FAILED, {reason: errorMessage}))
            return this.hasError = true
         })
   }
}


LibraryCardEditPickupLocationController.$inject = ['$uibModalInstance', 'rtaAvailabilityService', 'sierraService', 'configService', 'translationService', 'alertService', 'holdId', 'bibId']

angular.module('summonApp.controllers')
   .controller('libraryCardEditPickupLocationController', LibraryCardEditPickupLocationController)
